// src/features/captions/components/CaptionTermsEditor.tsx

import { useState } from 'react';
import { TagInput } from '@/shared/components/TagInput';
import { CAPTION_TERM_CONSTRAINTS } from '@/lib/constants/captions';
import { CaptionTermUtils } from '../CaptionTermUtils';

interface CaptionTermsEditorProps {
  label: string;
  value: string[];
  onChange: (terms: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
}

/**
 * Chips editor for a caption term set — TagInput with the server's term
 * normalization mirrored on every change (NFC, trim, whitespace collapse,
 * length rejection, case-insensitive dedupe, 200-term cap). Over-length
 * rejections surface inline instead of vanishing.
 */
export function CaptionTermsEditor({
  label,
  value,
  onChange,
  disabled = false,
  placeholder = 'Add a term...',
}: CaptionTermsEditorProps) {
  const [lengthError, setLengthError] = useState<string | null>(null);

  function handleChange(raw: string[]): void {
    const result = CaptionTermUtils.normalizeTerms(raw);
    setLengthError(CaptionTermUtils.formatTooLong(result.tooLong));
    onChange(result.terms);
  }

  return (
    <TagInput
      label={label}
      description={`${value.length}/${CAPTION_TERM_CONSTRAINTS.MAX_TERMS} terms`}
      value={value}
      onChange={handleChange}
      allTags={[]}
      maxTags={CAPTION_TERM_CONSTRAINTS.MAX_TERMS}
      error={lengthError ?? undefined}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
}
